module.exports = __webpack_public_path__ + "static/media/star.e196d544.svg";